import {
    faConciergeBell,
    faFilter,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { ApexOptions } from "apexcharts";
import { useRef, useState } from "react";
import Chart from "react-apexcharts";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { DashboardCorretorVendasController } from "../../../Controllers/Vendas/Usuario/UsuarioController";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import VisitasResumo from "./VisitasResumo/VisitasResumo";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import UnForm from "../../../Components/Form";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import { listarTipoAtividadesController } from "../../../Controllers/Geral/TipoAtividades";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AtividadesResumo from "./AtividadesResumo/AtividadesResumo";
import EmpreendimentoResumo from "./EmpreendimentoResumo/EmpreendimentoResumo";
import { useModuloInfo } from "../../../Context/ModuloInfo";

const filtroInicial: any = {
    ID_EMPREENDIMENTO: 0,
    ID_TIPO_ATIVIDADE: 0,
};

// Define o tipo para as opções de período
type Period = "hoje" | "semana" | "mes" | "ano";

// Define a interface para o intervalo de datas
interface DateRange {
    DT_INICIO: string;
    DT_FIM: string;
}

export default function PainelResumo() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { filter, setFilter } = usePaginationFilter<any>({ page: 1 });

    const { id } = useModuloInfo();

    const FormMethods = useForm();

    const { reset } = FormMethods;

    const now = moment().format("YYYY-MM-DD");

    const dtPeriodoInicial = useRef<string>(now);
    const dtPeriodoFinal = useRef<string>(now);

    const [selectedPeriod, setSelectedPeriod] = useState<Period>("hoje");

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ): void => {
        const newPeriod: Period = event.target.value as Period;
        setSelectedPeriod(newPeriod);
    };

    const { value: lstTipoAtividade, loading: lstTipoAtividadeLoading } =
        useAsyncEffect(async () => {
            if (id) return listarTipoAtividadesController(id, "");
        }, [id]);

    const { value: dashboardCorretor, loading: dashboardCorretorLoading } =
        useAsyncEffect(async () => {
            if (filter || dtPeriodoInicial || dtPeriodoFinal)
                return DashboardCorretorVendasController(
                    filter?.ID_TIPO_ATIVIDADE ? filter?.ID_TIPO_ATIVIDADE : 0,
                    filter?.ID_EMPREENDIMENTO ? filter?.ID_EMPREENDIMENTO : 0,
                    // "2021-01-01",
                    // "2024-12-31"
                    dtPeriodoInicial.current,
                    dtPeriodoFinal.current
                );
        }, [filter, dtPeriodoInicial, dtPeriodoFinal]);

    const calculateDateRange = (period: Period): DateRange => {
        switch (period) {
            case "hoje":
                dtPeriodoInicial.current = now;
                dtPeriodoFinal.current = now;

                break;
            case "semana":
                dtPeriodoInicial.current = moment()
                    .startOf("week")
                    .format("YYYY-MM-DD");
                dtPeriodoFinal.current = moment()
                    .endOf("week")
                    .format("YYYY-MM-DD");
                break;
            case "mes":
                dtPeriodoInicial.current = moment()
                    .startOf("month")
                    .format("YYYY-MM-DD");
                dtPeriodoFinal.current = moment()
                    .endOf("month")
                    .format("YYYY-MM-DD");
                break;
            case "ano":
                dtPeriodoInicial.current = moment()
                    .startOf("year")
                    .format("YYYY-MM-DD");
                dtPeriodoFinal.current = moment()
                    .endOf("year")
                    .format("YYYY-MM-DD");
                break;
            default:
                dtPeriodoInicial.current = now;
                dtPeriodoFinal.current = now;
        }

        return {
            DT_FIM: dtPeriodoFinal.current,
            DT_INICIO: dtPeriodoInicial.current,
        };
    };

    const atividadesSeries = [
        {
            name: `Planejadas`,
            data: [
                dashboardCorretor?.[0]?.NR_ATIVIDADES_AGENDADAS ?? 0,
                dashboardCorretor?.[0]?.NR_ATIVIDADES_EXECUTADAS ?? 0,
                dashboardCorretor?.[0]?.NR_ATIVIDADES_PENDENTES ?? 0,
                dashboardCorretor?.[0]?.NR_ATIVIDADES_DIA ?? 0,
            ],
        },
    ];

    const categories = ["Planejadas", "Executadas", "Atrasadas", "Para o Dia"];

    const atividadesOptions: ApexOptions = {
        chart: {
            type: "bar",
            events: {
                dataPointSelection: function (event, chartContext, config) {
                    const point = config.dataPointIndex;

                    if (point >= 0 && point < categories.length) {
                        const clickedCategory = categories[point];
                        setShow(true);
                        setModal({
                            IconHeader: faConciergeBell,
                            Component: () => (
                                <AtividadesResumo
                                    dtPeriodoFinal={dtPeriodoFinal}
                                    dtPeriodoInicial={dtPeriodoInicial}
                                    categoria={clickedCategory}
                                />
                            ),
                            size: "xl",
                            noFooter: true,
                            noHeader: true,
                            customBodyClasses: "p-0",
                        });
                    }
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "35%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: categories,
        },
        yaxis: {
            title: {
                text: "Total",
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: (val: number) => `${val} atividades`,
            },
        },
    };

    const vendas = dashboardCorretor
        ? dashboardCorretor.reduce(
              (acc: any, item: any) => {
                  acc.valorTotal += item.VL_TOTAL_VENDAS ?? 0;
                  acc.quantidadeTotal += item.NR_VENDAS_EMP ?? 0;
                  if (
                      acc.valorPorEmpreendimento[item.DS_EMPREENDIMENTO ?? ""]
                  ) {
                      acc.valorPorEmpreendimento[
                          item.DS_EMPREENDIMENTO ?? ""
                      ] += item.VL_TOTAL_VENDAS ?? 0;
                      acc.quantidadePorEmpreendimento[
                          item.DS_EMPREENDIMENTO ?? ""
                      ] += item.NR_VENDAS_EMP ?? 0;
                  } else {
                      acc.valorPorEmpreendimento[item.DS_EMPREENDIMENTO ?? ""] =
                          item.VL_TOTAL_VENDAS ?? 0;
                      acc.quantidadePorEmpreendimento[
                          item.DS_EMPREENDIMENTO ?? ""
                      ] = item.NR_VENDAS_EMP ?? 0;
                  }
                  return acc;
              },
              {
                  valorTotal: 0,
                  quantidadeTotal: 0,
                  valorPorEmpreendimento: {},
                  quantidadePorEmpreendimento: {},
              }
          )
        : {
              valorTotal: 0,
              quantidadeTotal: 0,
              valorPorEmpreendimento: {},
              quantidadePorEmpreendimento: {},
          };

    const idEmpreendimentoArray = Object.keys(
        vendas.valorPorEmpreendimento
    ).map((label) => {
        return dashboardCorretor?.find(
            (item: any) => item.DS_EMPREENDIMENTO === label
        )?.ID_EMPREENDIMENTO;
    });

    const vendasValorOptions: ApexOptions = {
        chart: {
            type: "pie",
            events: {
                dataPointSelection: function (event, chartContext, config) {
                    const point = config.dataPointIndex;
                    const idEmpreendimentoSelecionado =
                        idEmpreendimentoArray[point];

                    setShow(true);
                    setModal({
                        IconHeader: faConciergeBell,
                        Component: () => (
                            <EmpreendimentoResumo
                                dtPeriodoFinal={dtPeriodoFinal}
                                dtPeriodoInicial={dtPeriodoInicial}
                                ID_EMPREENDIMENTO={
                                    idEmpreendimentoSelecionado ?? 0
                                }
                            />
                        ),
                        size: "xl",
                        noFooter: true,
                        noHeader: true,
                        customBodyClasses: "p-0",
                    });
                },
            },
        },
        labels: Object.keys(vendas.valorPorEmpreendimento),
        legend: {
            position: "bottom",
        },
        tooltip: {
            y: {
                formatter: (val: number) => `${formatMoneyReais(val)}`,
            },
        },
    };

    const vendasValorSeries = Object.values(vendas.valorPorEmpreendimento);

    const vendasValorLabels = Object.keys(vendas.valorPorEmpreendimento);

    const vendasQuantidadeOptions: ApexOptions = {
        chart: {
            type: "pie",
        },
        labels: Object.keys(vendas.quantidadePorEmpreendimento),
        legend: {
            position: "bottom",
        },
        tooltip: {
            y: {
                formatter: (val: number) => `${val} vendas`,
            },
        },
    };

    const vendasQuantidadeSeries = Object.values(
        vendas.quantidadePorEmpreendimento
    );

    const vendasQuantidadeLabels = Object.keys(
        vendas.quantidadePorEmpreendimento
    );

    const visitasSeries = [
        {
            name: "Agendadas",
            data: [dashboardCorretor?.[0]?.NR_VISITAS_AGENDADAS ?? 0],
        },
        {
            name: "Realizadas",
            data: [dashboardCorretor?.[0]?.NR_VISITAS_REALIZADAS ?? 0],
        },
        {
            name: "Pendentes",
            data: [dashboardCorretor?.[0]?.NR_VISITAS_PENDENTES ?? 0],
        },
    ];

    const visitasOptions: ApexOptions = {
        chart: {
            type: "bar",
            events: {
                dataPointSelection: function (event, chartContext, config) {
                    const visitaStatus =
                        config.w.config.series[config.seriesIndex].name;

                    setShow(true);
                    setModal({
                        IconHeader: faConciergeBell,
                        Component: () => (
                            <VisitasResumo
                                dtPeriodoFinal={dtPeriodoFinal}
                                dtPeriodoInicial={dtPeriodoInicial}
                                visitaStatus={visitaStatus}
                            />
                        ),
                        size: "xl",
                        noFooter: true,
                        noHeader: true,
                        customBodyClasses: "p-0",
                    });
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "25%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: ["Visitas"],
        },
        yaxis: {
            title: {
                text: "Total",
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: (val: number) => `${val} visitas`,
            },
        },
    };

    function handleFilter(formData: any) {
        const { DT_INICIO, DT_FIM } = calculateDateRange(selectedPeriod);

        dtPeriodoInicial.current = DT_INICIO;
        dtPeriodoFinal.current = DT_FIM;

        const filterFormData: any = {
            ID_TIPO_ATIVIDADE: formData.ID_TIPO_ATIVIDADE,
            ID_EMPREENDIMENTO: formData.ID_EMPREENDIMENTO,
        };

        setFilter(filterFormData);
    }

    const leadsSeries = [
        {
            name: "Volume de Leads Gerados",
            data: [dashboardCorretor?.[0]?.NR_VOLUME_LEADS_GERADOS ?? 0],
        },
        {
            name: "Taxa de Conversão de Leads",
            data: [dashboardCorretor?.[0]?.NR_TAXA_CONVERSAO_LEADS ?? 0],
        },
    ];

    const leadsOptions: ApexOptions = {
        chart: {
            type: "bar",
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "35%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories: ["Leads"],
        },
        yaxis: {
            title: {
                text: "Volume/Taxa",
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: (val: number, opts) => {
                    if (opts.seriesIndex === 1) {
                        return `${val}%`;
                    }
                    return `${val} leads`;
                },
            },
        },
    };

    return (
        <div>
            <h1>Resumo de Performance</h1>{" "}
            <FormProvider {...FormMethods}>
                <OrSpinner loading={lstTipoAtividadeLoading} spinner="capys">
                    <UnForm
                        handleSubmit={handleFilter}
                        className="card p-3"
                        usingContext
                    >
                        <div className="row align-items-end">
                            <div className="col-md-4">
                                <label>Período</label>
                                <UnForm.Select
                                    className="form-control"
                                    name="DT_PERIODO"
                                    onChange={handleSelectChange}
                                >
                                    <option value="hoje">Hoje</option>
                                    <option value="semana">Semana</option>
                                    <option value="mes">Mês</option>
                                    <option value="ano">Ano</option>
                                </UnForm.Select>
                            </div>
                            <div className="col-md-3">
                                <UnForm.LazySelect
                                    className="col-12"
                                    label={"Empreendimento"}
                                    controller={ListarEmpreendimentosController}
                                    getDS={(e) => e.DS_EMPREENDIMENTO}
                                    getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                                    name="ID_EMPREENDIMENTO"
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                            <div className="col-md-3">
                                <UnForm.Select
                                    label="Tipo Atividade"
                                    name="ID_TIPO_ATIVIDADE"
                                    defaultValue={filter?.ID_TIPO_ATIVIDADE}
                                    className="form-control"
                                >
                                    <option value=""></option>
                                    {lstTipoAtividade?.map((tipoAtividade) => (
                                        <option
                                            key={
                                                tipoAtividade.ID_TIPO_ATIVIDADE
                                            }
                                            value={
                                                tipoAtividade.ID_TIPO_ATIVIDADE
                                            }
                                        >
                                            {tipoAtividade.DS_TIPO_ATIVIDADE}
                                        </option>
                                    ))}
                                </UnForm.Select>
                            </div>
                            <div className="col-md-1 m-0 p-0">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`filtrar-eventos`}>
                                            Filtrar
                                        </Tooltip>
                                    }
                                >
                                    <UnForm.SubmitButton
                                        color="dark"
                                        wrapperClassName="d-flex justify-content-center m-0 p-0"
                                        icon={faFilter}
                                    ></UnForm.SubmitButton>
                                </OverlayTrigger>
                            </div>
                            <div className="col-md-1">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`limpar-filtros-eventos`}>
                                            Limpar Filtros
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        type="button"
                                        onClick={() => {
                                            reset(filtroInicial);
                                            setSelectedPeriod("hoje");
                                        }}
                                        className="btn btn-outline-danger d-flex align-items-center justify-content-center"
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </UnForm>
                </OrSpinner>
            </FormProvider>
            <div className="row my-4">
                <div className="col-xl-4">
                    <div className="card card-custom gutter-b card-stretch p-3">
                        <OrSpinner
                            loading={dashboardCorretorLoading}
                            spinner="capys"
                        >
                            <h6>
                                {dashboardCorretor?.[0]
                                    ?.NR_VOLUME_TOTAL_ATIVIDADES ?? 0}{" "}
                                Atividades
                            </h6>
                            <Chart
                                options={atividadesOptions}
                                series={atividadesSeries ?? []}
                                type="bar"
                                height={300}
                            />
                        </OrSpinner>
                    </div>
                </div>

                <div className="col-xl-4">
                    <div className="card card-custom gutter-b card-stretch p-3">
                        <OrSpinner
                            loading={dashboardCorretorLoading}
                            spinner="capys"
                        >
                            <h6>
                                {(dashboardCorretor?.[0]
                                    ?.NR_VISITAS_AGENDADAS ?? 0) +
                                    (dashboardCorretor?.[0]
                                        ?.NR_VISITAS_PENDENTES ?? 0) +
                                    (dashboardCorretor?.[0]
                                        ?.NR_VISITAS_REALIZADAS ?? 0)}{" "}
                                Visitas
                            </h6>
                            <Chart
                                options={visitasOptions}
                                series={visitasSeries ?? []}
                                type="bar"
                                height={300}
                            />
                        </OrSpinner>
                    </div>
                </div>

                <div className="col-xl-4">
                    <div className="card card-custom gutter-b card-stretch p-3">
                        <OrSpinner
                            loading={dashboardCorretorLoading}
                            spinner="capys"
                        >
                            <h6>
                                {formatMoneyReais(vendas.valorTotal)} Vendas -
                                Valor por Empreendimento
                            </h6>
                            {vendasValorSeries &&
                            vendasValorSeries.length > 0 &&
                            vendasValorSeries[0] !== 0 ? (
                                <Chart
                                    options={{
                                        ...vendasValorOptions,
                                        labels: vendasValorLabels,
                                    }}
                                    series={vendasValorSeries ?? []}
                                    type="donut"
                                    height={300}
                                />
                            ) : (
                                <div className="d-flex justify-content-center align-items-center my-auto">
                                    <h6>Nenhuma venda realizada no período</h6>
                                </div>
                            )}
                        </OrSpinner>
                    </div>
                </div>

                <div className="col-xl-4">
                    <div className="card card-custom gutter-b card-stretch p-3">
                        <OrSpinner
                            loading={dashboardCorretorLoading}
                            spinner="capys"
                        >
                            <h6>
                                {vendas.quantidadeTotal} Vendas - Quantidade por
                                Empreendimento
                            </h6>
                            {vendasQuantidadeSeries &&
                            vendasQuantidadeSeries.length > 0 &&
                            vendasQuantidadeSeries[0] !== 0 ? (
                                <Chart
                                    options={{
                                        ...vendasQuantidadeOptions,
                                        labels: vendasQuantidadeLabels,
                                    }}
                                    series={vendasQuantidadeSeries ?? []}
                                    type="pie"
                                    height={300}
                                />
                            ) : (
                                <div className="d-flex justify-content-center align-items-center my-auto">
                                    <h6>Nenhuma venda realizada no período</h6>
                                </div>
                            )}
                        </OrSpinner>
                    </div>
                </div>

                <div className="col-xl-4">
                    <div className="card card-custom gutter-b card-stretch p-3">
                        <OrSpinner
                            loading={dashboardCorretorLoading}
                            spinner="capys"
                        >
                            <h6>Leads Gerados e Taxa de Conversão</h6>
                            {leadsSeries && (
                                <Chart
                                    options={leadsOptions}
                                    series={leadsSeries ?? []}
                                    type="bar"
                                    height={300}
                                />
                            )}
                        </OrSpinner>
                    </div>
                </div>
            </div>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
